import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

type Props = {
  id: string
  enabled?: boolean
}

export const useGetPublicPortfolioId = ({ id, enabled = true }: Props) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['portfolioPublicId', id],
    queryFn: () => projectService.portfolio.getPublicPortfolioId(id),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar o portfólio',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    return {
      portfolio: data,
      isLoading,
      refetchPortfolio: refetch,
      isError,
    }
  }

  return {
    portfolio: null,
    isLoading,
    refetchPortfolio: refetch,
    isError,
  }
}
